

































































































































import Vue from "vue";
import { Watch } from "vue-property-decorator";
import Component from "vue-class-component";
import { NavBar, Col, Row, Image as VanImage, Divider, Notify,Popup } from "vant";
import QRCode from 'qrcode'
Vue.use(NavBar);
Vue.use(Col);
Vue.use(Row);
Vue.use(VanImage);
Vue.use(Divider);
Vue.use(Notify);
Vue.use(Popup);
@Component
export default class ManCard extends Vue {
  businessCard='http://yths.zgftlm.com/static/businessCard_zhangxq.png'
  show=false
  show1=false
  onClickLeft() {
    this.$router.back();
  }
  cardUrl=''
  onCopy(data: any) {
    Notify({ type: "success", message: "邮箱已复制至粘贴板" });
  }
  onError() {
    Notify({ type: "danger", message: "邮箱复制失败" });
  }
  saveBook(){
    this.show1 = true
    let text = 'BEGIN:VCARD'
     text +='\r\nN:张;晓庆'
     text +='\r\nTEL;TYPE=WORK,VOICE:13068002051'
    //  text +='\r\nEMAIL;TYPE=PREF,INTERNET:3903469595@163.com'
    text += '\r\nEND:VCARD'
    QRCode.toDataURL(text, (err: any, url: string) => {
      this.cardUrl = url
    })
  }
  downLoadCard(imgsrc:any){
   
    this.show=true
  }
  gotoJkzl(){
    window.location.href="/health"
  }
  getUrlBase64(url:any) {
      return new Promise(resolve => {
        let canvas:any = document.createElement('canvas')
        let ctx:any= canvas.getContext('2d')
        let img = new Image()
        img.crossOrigin = 'Anonymous' //允许跨域
        img.src = url
        img.onload = function() {
          canvas.height = 300
          canvas.width = 300
          ctx.drawImage(img, 0, 0, 300, 300)
          let dataURL = canvas.toDataURL('image/png')
          canvas = null
          resolve(dataURL)
        }
      })
    }
}
